import React from 'react';
import { TextTypes } from '../Text';
import './style.scss';
import ContactFormLegacy from './ContactFormLegacy';
import ContactFormUpdated from './ContactFormUpdated';

type ContactFormProps = {
  className?: string;
  onSuccess?: () => void;
  titleTagType?: TextTypes;
  isLegacy?: boolean;
};

const ContactForm: React.FC<ContactFormProps> = ({
  titleTagType = 'h1',
  isLegacy = true,
  ...props
}) => {
  return isLegacy ? (
    <ContactFormLegacy titleTagType={titleTagType} {...props} />
  ) : (
    <ContactFormUpdated titleTagType={titleTagType} {...props} />
  );
};

export default React.memo(ContactForm);
